/* BBT Theme 117: conservative internal-search alias + deterministic part-number normalisation.
 * Only obvious equivalent workshop terms/spelling variants are rewritten.
 * Exact tag queries, fielded Shopify queries, boolean expressions and IDs are left untouched.
 */
(function () {
  'use strict';

  var RULES = [
    [/\bcustom\s+plenum\s+creations\b/gi, 'cpc'],
    [/\bturbo\s+smart\b/gi, 'turbosmart'],
    [/\bplazma\s+man\b/gi, 'plazmaman'],
    [/\bdeatsch\s+werks\b/gi, 'deatschwerks'],
    [/\bblow\s*off\s+valves?\b/gi, 'BOV'],
    [/\bblowoff\s+valves?\b/gi, 'BOV'],
    [/\bwaste\s+gate\b/gi, 'wastegate'],
    [/\binter\s+cooler\b/gi, 'intercooler'],
    [/\banti[-\s]+roll\s+bar\b/gi, 'sway bar'],
    [/\bswaybar\b/gi, 'sway bar'],
    [/\bcatchcan\b/gi, 'catch can'],
    [/\bchargepipe\b/gi, 'charge pipe'],
    [/\btrans\s+cooler\b/gi, 'transmission cooler'],
    [/\btailshaft\b/gi, 'driveshaft'],
    [/\bprop\s*shaft\b/gi, 'driveshaft'],
    [/\bgearbox\b/gi, 'transmission'],
    [/\bdiff\b/gi, 'differential'],
    [/\bfuelling\b/gi, 'fuel'],
    [/\bfueling\b/gi, 'fuel'],
    [/\becm\b/gi, 'ECU'],
    [/\bfpr\b/gi, 'fuel pressure regulator'],
    [/\bcoil\s+packs?\b/gi, 'ignition coil'],
    [/\bspark\s+plugs\b/gi, 'spark plug'],
    [/\bboost\s+controller\b/gi, 'boost control'],
    [/\bcat\s+back\b/gi, 'catback'],
    [/\b4g63t\b/gi, '4G63'],
    [/\btt\s+rs\b/gi, 'TTRS'],
    [/\bvf\s*(?:2|ii)\b/gi, 'VFII'],
    [/\br(32|33|34)\s+gtr\b/gi, 'R$1 GT-R'],
    [/\bxr6t\b/gi, 'XR6 Turbo'],
    [/\bm140\b/gi, 'M140i'],
    // Deterministic brand / manufacturer part-number formats proven across the fresh catalogue.
    // These accept missing separators without changing any numeric-only or ambiguous part numbers.
    [/\bHT[\s-]?(\d{6})\b/gi, 'HT-$1'],
    [/\bTS[\s-]?(\d{4})[\s-]?(\d{4})\b/gi, 'TS-$1-$2']
  ];

  function protectedQuery(value) {
    return /(^|\s)(?:tag:|id:|vendor:|product_type:|variants\.sku:|sku:)/i.test(value) ||
      /\s(?:OR|AND|NOT)\s/i.test(value);
  }

  function normalise(value) {
    var original = String(value || '').trim();
    if (!original || protectedQuery(original)) return original;
    var result = original;
    RULES.forEach(function (entry) { result = result.replace(entry[0], entry[1]); });
    return result.replace(/\s{2,}/g, ' ').trim();
  }

  function searchURLFromForm(form, canonical) {
    var action = new URL(form.action || '/search', window.location.origin);
    var data = new FormData(form);
    data.forEach(function (value, key) {
      if (key !== 'q' && typeof value === 'string' && value !== '') action.searchParams.append(key, value);
    });
    action.searchParams.set('q', canonical);
    return action;
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action;
    try { action = new URL(form.action || window.location.href, window.location.origin); } catch (e) { return; }
    if (!/\/search\/?$/.test(action.pathname)) return;
    var input = form.querySelector('input[name="q"]');
    if (!(input instanceof HTMLInputElement)) return;
    var raw = input.value.trim(), canonical = normalise(raw);
    if (!canonical || canonical === raw) return;
    event.preventDefault();
    var target = searchURLFromForm(form, canonical);
    window.location.assign(target.pathname + target.search + target.hash);
  }, true);

  // Direct /search?q=... links receive the same conservative normalisation.
  try {
    var current = new URL(window.location.href);
    if (/\/search\/?$/.test(current.pathname)) {
      var raw = (current.searchParams.get('q') || '').trim();
      var canonical = normalise(raw);
      if (canonical && canonical !== raw) {
        current.searchParams.set('q', canonical);
        window.location.replace(current.pathname + current.search + current.hash);
      }
    }
  } catch (e) {}

  window.BBTSearchAliases = Object.freeze({ version: '117-12sep2026', normalise: normalise });
})();
